import { App } from "@/app";
import { Transition as BaseTransition } from "@unseenco/taxi";
import { Nav } from "@/classes/Nav";
import gsap from "@lib/gsap";

let previousUrl: string | null | undefined = null;
const nav = new Nav();
/* -- Baseline Transition */
export class Transition extends BaseTransition {
  async onLeave({
    from,
    trigger,
    done,
  }: {
    from: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    previousUrl = document
      .querySelector("[data-taxi-view]")
      ?.getAttribute("data-taxi-url");

    await gsap.to(from, {
      opacity: 0,
      duration: 0.2,
      ease: "accelerate",
    });

    await App.pages.transitionOut({ from, trigger });
    done();
  }

  async onEnter({
    to,
    trigger,
    done,
  }: {
    to: Element | HTMLElement;
    trigger: string | false | HTMLElement;
    done: Function;
  }) {
    nav.setpageUrl(window.location.pathname);
    nav.setActiveNavItem();
    nav.handleRouteChange(previousUrl);

    gsap.set(to, { opacity: 0 });
    await App.pages.transitionIn({ to, trigger });

    await gsap.delayedCall(0.2, () => {});
    nav.closeMenu();

    await gsap.to(to, {
      opacity: 1,
      duration: 0.6,
      ease: "accelerate",
    });
    done();
  }
}

/* -- ... Transition */
